import { CheckCircleFilled, MinusOutlined } from '@ant-design/icons';

const BADGEBASE =
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold leading-5 whitespace-nowrap';
const CompletedCell = ({ value }: { value: boolean }) =>
  value ? (
    <div className={`${BADGEBASE} text-success-700 bg-success-50`}>
      <span className="inline-flex text-[11px]">
        <CheckCircleFilled />
      </span>
      <span>Done</span>
    </div>
  ) : (
    <span className="text-neutral-60">
      <MinusOutlined />
    </span>
  );

export default CompletedCell;
